module.exports = __webpack_public_path__ + "img/newpage-bg.51e1e61d.jpg";